import logo from './logo.svg';
import './App.css';
import Header from './Components/Header';
import Home from './Components/Home';
import Products from './Components/Pages/Products';
import Gallery from './Components/Pages/Gallery';
import About from './Components/Pages/About';
import Contact from './Components/Pages/Contact';
import Services from './Components/Pages/Services';
import { Routes, Route } from 'react-router-dom';
import Footer from './Components/Footer';

import Team from './Components/Pages/Team.js';
import Muhammadabad from './Components/BlogPages/Muhammadabad.js';
import Mubarakpur from './Components/BlogPages/Mubarakpur.js';
import Mau from './Components/BlogPages/Mau.js';
import Ghosi from './Components/BlogPages/Ghosi.js';
import Chiraiyakot from './Components/BlogPages/Chiraiyakot.js';
import Azamgarh from './Components/BlogPages/Azamgarh.js';
import SeoFooter from './Components/Pages/SeoFooter.js';
import Banner from './Components/Banner/Banner.js';
import ReviewPage from './Components/Pages/ReviewPage.js';

function App() {
  return (
    <div className="App ">
      <Header />
      <Banner/>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/team" element={<Team />} />
          <Route path="/reviews" element={<ReviewPage />} />


         <Route  path="/aluminium-window-works-muhammadabad-gohna" element={<Muhammadabad />} />
          <Route  path="/aluminium-works-mubarakpu" element={< Mubarakpur/>} />
           <Route  path="/aluminium-works-mau" element={< Mau/>} />
            <Route  path="/aluminium-works-ghosi" element={< Ghosi/>} />
             <Route  path="/aluminium-works-chiraiyakot" element={<Chiraiyakot />} />
              <Route  path="/aluminium-works-azamgarh" element={< Azamgarh/>} />
              


      </Routes>
<SeoFooter/>
       <Footer/>
    </div>
  );
}

export default App;
